webpackJsonp([80],{

/***/ 1310:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1311);


/***/ }),

/***/ 1311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(169);

var _datetime2 = _interopRequireDefault(_datetime);

var _enCa = __webpack_require__(794);

var _enCa2 = _interopRequireDefault(_enCa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-ca', _enCa2.default);

/***/ })

},[1310]);


// WEBPACK FOOTER //
// app/datetime.en-ca-d62deb537d043aff2149.js